import { render, staticRenderFns } from "./PassosFornecedorVsComprador.vue?vue&type=template&id=79566bce"
import script from "./PassosFornecedorVsComprador.vue?vue&type=script&lang=js"
export * from "./PassosFornecedorVsComprador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports